export const handlers = [
  // Add MSW handlers here which you need for development, e.g.:
  // graphql.query<ResultOf<typeof accreditationsQuery>, VariablesOf<typeof accreditationsQuery>>(
  //   accreditationsQuery,
  //   () => {
  //     return HttpResponse.json({
  //       data: {
  //         supplyChainBookingAccreditations: [
  //           { id: "b66fe4c3-8b16-4c25-8662-2c9d2bb9433f", label: "Acc 1", status: "ACTIVE" },
  //           { id: "d7a1f3e5-9c42-4b8a-95d3-6f8e24c1a2b0", label: "Acc2", status: "ACTIVE" },
  //         ],
  //       },
  //     });
  //   },
  // ),
];
